<script>
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import { fly } from "svelte/transition";
  import { appConstants } from "../stores/app.js";
  import { ScrollingDisable, ScrollingEnable } from "../library/util.js";

  const dispatch = createEventDispatcher();

  onMount(async () => {
    ScrollingDisable();
  });

  onDestroy(() => {
    ScrollingEnable();
  });

  function Continue() {
    dispatch("close", {});
  }
</script>

<div class="overlay-page-wrapper" transition:fly={{ y: 200, duration: 500 }}>
  <div class="welcome-banner" />

  <div class="overlay-page-body">
    <div class="container">
      <div class="welcome">
        <p style="font-weight: 500; font-size: 1.3em; margin-top: 0;">Welcome to JumpHub!</p>

        <p>We have created the JumpHub pilot program just for you.</p>
        <p>
          For your convenience, you may want to add the JumpHub pilots link to your smartphone's homepage.<br />
          Pilots log in can be reached again at <a href="https://pilot.jumphub.aero">pilot.jumphub.aero</a>
        </p>

        <p class="section-header">JumpHub ID <i class="material-icons inline-icon">perm_identity</i></p>
        <p>
          Be sure to check your JumpHub ID carefully before use. If there are any discrepancies with your information,
          please contact your operator.
        </p>
        <p>
          Your JumpHub ID serves as proof of employment and participation in the program. This has a distinctive
          animated tick and date to show that it is current.
        </p>
        <p>JumpHub ID’s are designed to be used in conjunction with a company issued ID and pilot credentials.</p>

        <p class="section-header">Searching for jumpseats <i class="material-icons inline-icon">search</i></p>

        <p>You can search for jumpseats by entering a departure, destination or both using the ICAO identifier.</p>

        <p>Results will be returned within a specific range of your desired airports.</p>

        <p>JumpHub will return results up to 14 days in advance.</p>

        <p>Most empty legs are likely to appear closer to your desired departure date so check back frequently.</p>

        <p>
          Please bring any missing codes to our attention at <a href="mailto:feedback@jumphub.aero"
            >feedback@jumphub.aero</a
          >
        </p>

        <p class="section-header">
          Jumpseat Requests <img src="assets/jumpseat.png" alt="" style="vertical-align: text-bottom;" />
        </p>

        <p>To request a jumpseat, simply click on the desired search result.</p>
        <p>
          You can have a maximum of {$appConstants.pendingRequestLimit} pending requests, please be considerate of operators
          when making unecessary or excessive requests, as this will waste operators time.
        </p>

        <p class="section-header">International Flights</p>

        <p>
          International jumpseat requests should be submitted at least 24 hours in advance to allow the operator time to
          process your request.
        </p>
        <p>
          Due to the increased workload associated with processing international requests, these will be handled only if
          operational demands allow.
        </p>
        <p>Please have your passport information on hand to pass along to an operator if a request has been made.</p>

        <p class="section-header">Cancelling a Request</p>

        <p>In the requests page, simply click on a pending or approved flight and hit cancel.</p>

        <p>If the flight was departing within 48 hours, the operator will be notified of the cancellation.</p>

        <p class="section-header">Receiving Flight Details</p>
        <p>
          Once a jumpseat request has been approved, you will receive an email notification of approval, you can then
          log in to JumpHub and check the flight details. Simply click on an approved flight to receive all information
          required to board. This includes operator information, jumpseat policies, tail or flight numbers and notes
          from the operator.
        </p>

        <p>
          Important: Being pre-approved for a flight does not give you authority to access the aircraft or any secure
          areas. You will still be subject to security vetting by the captain or authorized agent.
        </p>

        <p>
          Due to the nature of operational demands, flight status changes regularly and sometimes at short notice. If
          you are denied, please conduct yourself in a professional manner and try again.
        </p>

        <p>
          If you have never jumpseated before we suggest you visit www.jumpseatinfo.org for common jumpseat etiquette.
        </p>

        <p class="section-header">Cancelling your subscription</p>

        <p>
          You can cancel your subscription at any time. If your employment ends with an operator, your access will be
          removed from JumpHub immediately and your subscription cancelled.
        </p>

        <p>
          You will be able to rejoin if your next employer is a member of JumpHub and enrolls you under their operation.
        </p>

        <p>In all instances of cancellation, we do not refund for the remainder of the billing month.</p>

        <p class="section-header">For more information</p>

        <p>
          For more information on how the system works, please visit the pilot FAQ’s section on <a
            href="https://www.jumphub.aero"
            target="_blank">www.jumphub.aero</a
          >
          or visit us on <a href="https://www.facebook.com/JumpHub/" target="_blank">Facebook</a>.
        </p>

        <p>
          We have many updates planned for the JumpHub program which will continue to benefit pilots and operators
          alike. So we would love to hear your feedback on what we can do for you, this can be provided via email at <a
            href="mailto:feedback@jumphub.aero">feedback@jumphub.aero</a
          >
        </p>

        <p class="section-header">Help grow your available network.</p>

        <p>
          You can help increase your opportunities by talking to other pilots and operators about participating in
          JumpHub. With each operator that joins your options increase exponentially.
        </p>

        <p>Safe flying<br /> <b>The JumpHub team</b></p>
      </div>
    </div>
  </div>

  <div class="overlay-page-footer">
    <div class="container">
      <div class="right"><button class="btn-flat waves-effect" on:click={Continue}>got it</button></div>
    </div>
  </div>
</div>

<style>
  .welcome-banner {
    background: url(../assets/welcome-banner.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    height: 30vh;
  }
  @media only screen and (min-width: 768px) {
    .welcome-banner {
      height: 50vh;
    }
  }

  .welcome {
    font-size: 0.9em;
  }

  p.section-header {
    margin-top: 20px;
    font-weight: 500;
    font-size: 1.1em;
  }
  .inline-icon {
    position: relative;
    top: 8px;
    font-size: 28px;
  }
</style>
